<template>
  <div @click="toggleAvatar" :class="[custom]" class="group h-11 group rounded-full flex items-center relative">
    <div class="open-user-menu w-11 h-11 rounded-full hidden items-center justify-center transition-all duration-100">
      <base-icon :name="setArrow" :class="{ 'transform rotate-180': isOpen }" class="group-hover:text-secondary transition-transform duration-300" />
    </div>
    <div :class="css" class="w-11 h-11 rounded-full overflow-hidden relative">
      <span v-if="zoom" class="zoom" @click="$emit('click')">
        <i class="el-icon-zoom-in text-slate-500"></i>
      </span>
      <img v-if="src" :src="src" alt="Socio del grupo" class="object-cover" />
      <span v-else-if="icon" class="text-white">
        <base-icon :name="icon" />
      </span>
      <span v-else class="text-white">{{ letter }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseAvatar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    custom: {
      type: [String, Array],
      default: ''
    },
    onMobile: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    letter: {
      type: String,
      required: false
    },
    zoom: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {}
  },
  computed: {
    setArrow: function () {
      return this.onMobile ? 'chevronup' : 'chevrondown'
    },
    css: function () {
      return {
        flex: !this.src,
        'justify-center': !this.src,
        'items-center': !this.src,
        'bg-secondary': this.icon !== 'error',
        'bg-red-600': this.icon === 'error'
      }
    }
  },
  methods: {
    toggleAvatar: function () {
      this.$emit('toggleAvatar')
    }
  }
}
</script>

<style lang="scss" scoped>
.zoom {
  @apply absolute left-0 top-0 w-full h-full flex justify-center items-center bg-slate-50 opacity-0 hover:opacity-90 cursor-pointer transition-all;
  i {
    font-weight: bold !important;
  }
}
</style>
